import React from "react";
import { DefaultThemeData } from "./themedata";

export const ThemeContext = React.createContext(DefaultThemeData);
